import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/', icon: '🏆', label: 'لوحة التصنيف', public: true },
  { to: '/players', icon: '👤', label: 'اللاعبون', public: true },
  { to: '/tournaments', icon: '🎯', label: 'البطولات', public: true },
];

const adminItems = [
  { to: '/dashboard', icon: '📊', label: 'لوحة التحكم', roles: ['admin','editor'] },
  { to: '/point-rules', icon: '⚙️', label: 'نقاط القواعد', roles: ['admin'] },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div style={{ fontSize: 36, marginBottom: 8 }}>🏅</div>
          <h1>منصة التصنيف الرياضي</h1>
          <p>Sports Ranking Platform</p>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-label">القائمة الرئيسية</div>
            {navItems.map(item => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <span className="icon">{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>

          {user && (
            <div className="nav-section">
              <div className="nav-label">الإدارة</div>
              {adminItems.filter(i => i.roles.includes(user.role)).map(item => (
                <NavLink key={item.to} to={item.to}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                  <span className="icon">{item.icon}</span>
                  {item.label}
                </NavLink>
              ))}
            </div>
          )}
        </nav>

        <div style={{ padding: '16px 12px', borderTop: '1px solid var(--border)' }}>
          {user ? (
            <div>
              <div style={{ padding: '8px 14px', marginBottom: 8 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{user.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{user.role === 'admin' ? 'مدير النظام' : 'محرر'}</div>
              </div>
              <button className="nav-item" onClick={handleLogout}>
                <span className="icon">🚪</span> تسجيل الخروج
              </button>
            </div>
          ) : (
            <NavLink to="/login" className="nav-item">
              <span className="icon">🔐</span> تسجيل الدخول
            </NavLink>
          )}
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
